/* eslint-disable react/no-array-index-key */
import React, {
  FC, memo, useEffect, useRef, useState,
} from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import logo from '../../assets/agreement/logo.svg';
import { agreementCols, agreementTable, agreementText } from './agreementText';
import { ACCURACY } from './constants';
import { agreementNextButton, StyledTableCell, StyledTableCellAgreement } from './mui';
import { ImgBox } from '../../share/components/ImgBox';
import { IParagraph } from './types/intex';
import './css/index.css';
import { AgreementContainer } from '../../share/style/styled';

type PropTypes = {
  handleAgree : any
};

const Agreement: FC<PropTypes> = memo(({ handleAgree }) => {
  const [state, setState] = useState<HTMLDivElement | null>(null);
  const [disable, setDisable] = useState(true);
  const listInnerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    setState(listInnerRef.current);
  }, []);

  /**
   * If the user has scrolled to the bottom of the page, disable the button
   */
  const onScroll = () => {
    const bottom = Math.abs((Number(state?.scrollHeight)
      - Number(state?.scrollTop))
      - Number(state?.clientHeight)) <= ACCURACY;
    if (bottom) {
      setDisable(false);
    }
  };
  return (
    <AgreementContainer h="100%" d="column" wrap="nowrap" ai="center" ac="stretch">
      <div className="agreement-logo">
        <ImgBox image={logo} text="logo" />
      </div>
      <div className="agreement-content">
        <div className="agreement-instructions">
          <Typography variant={'agreementInstructions' as any}>
            Scroll down to approve
          </Typography>
        </div>
        <Paper
          className={'agreement-rules' as string}
          elevation={0 as number}
          onScroll={onScroll as any}
          ref={listInnerRef as any}
        >
          <Typography paragraph variant={'agreement_title' as any}>
            Evaluation Agreement
          </Typography>
          {agreementText.map((paragraph: IParagraph, i) => (
            <React.Fragment key={i.toString()}>
              <Typography paragraph variant={'agreement_paragraph_title' as any}>
                {paragraph.title}
              </Typography>
              <Typography paragraph variant={'agreement_description' as any}>
                {paragraph.description}
              </Typography>
            </React.Fragment>
          ))}
          <>
            <Typography paragraph variant={'agreement' as any}>
              {agreementTable.description}
            </Typography>
            <TableContainer component={Paper}>
              <Table size="small" aria-label="price list">
                <TableHead>
                  <TableRow>
                    {agreementCols.map((col) => (
                      <StyledTableCellAgreement key={col.id}>
                        <Typography paragraph variant={'price_title' as any}>
                          {col.name}
                        </Typography>
                      </StyledTableCellAgreement>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {agreementTable.rows.map((row: any) => (
                    <TableRow key={row.servicePlan}>
                      <StyledTableCell component="th" scope="row">
                        <Typography paragraph variant={'price' as any}>
                          {row.servicePlan}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        <Typography paragraph variant={'price' as any}>
                          {row.pricing}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        <Typography paragraph variant={'price' as any}>
                          {row.betaDiscount}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        <Typography paragraph variant={'price' as any}>
                          {row.maxSizeOfFloorPlanPerProject}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        <Typography paragraph variant={'price' as any}>
                          {row.numberOfUsers}
                        </Typography>
                      </StyledTableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        </Paper>
        <div style={{ marginTop: '15px' }}>
          {agreementNextButton(disable, handleAgree)}
        </div>
      </div>
    </AgreementContainer>
  );
});
Agreement.displayName = 'Agreement';
export default Agreement;
